export default __webpack_public_path__ + "static/media/trash-circle.bc33da99.svg";